import React from "react";
import PropTypes from "prop-types";
const ReloadIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <title>{title}</title>
    <g
      fill="none"
      stroke={color || "var(--color-easil-gray-x-dark)"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    >
      <path d="M11 7l2 2 2-2" />
      <path d="M13 9V6a3 3 0 00-3-3H4M5 9L3 7 1 9" />
      <path d="M3 7v3a3 3 0 003 3h6" />
    </g>
  </svg>
);

ReloadIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object
};

export default ReloadIcon;
